import moment from 'moment';

/**
 * This util converts all dates with the attribute 'data-local-date' to local date.
 * - data-local-date (mandatory): the date/instant string that should get converted
 * - data-locale-date-format (optional): should contain at least one '{}' as placeholder for the formatted date
 * - data-locale-date-target-attribute (optional): the target attribute in which the date will be written
 *  (the fallback is the inner html of the element)
 */
export function registerConvertLocalDate() {
  const localDateElements = document.querySelectorAll<HTMLElement>('[data-local-date]');

  localDateElements.forEach((element) => {
    const localDateValue = element.dataset.localDate;

    if (localDateValue) {
      const format = element.dataset.localeDateFormat || '{}';
      const withDate = (element.dataset.withDate || 'true') === 'true';
      const withTime = (element.dataset.withTime || 'true') === 'true';
      const formattedDateString = formatDateString(localDateValue, format, withDate, withTime);

      const targetAttribute = element.dataset.localeDateTargetAttribute;
      if (targetAttribute) {
        element.setAttribute(targetAttribute, formattedDateString);
      } else {
        element.innerHTML = formattedDateString;
      }
    }
  });
}

function formatDateString(localDateValue: string, format: string, withDate: boolean, withTime: boolean): string {
  const formats = [];

  if (withDate) {
    formats.push('L');
  }

  if (withTime) {
    formats.push('LT');
  }

  if (formats.length === 0) {
    throw new Error('No format specified.');
  }

  const formattedDateString = moment(localDateValue).format(formats.join(', '));
  return format.replace('{}', formattedDateString);
}
